module.exports = __webpack_public_path__ + "img/icon-navigation-subtract.0bc91563.svg";